const departmentOptions = [
  {
    value: 'Biotechnology and Biochemical Engineering',
    label: 'Biotechnology and Biochemical Engineering'
  },
  {
    value: 'Chemical and Alcohol Technology',
    label: 'Chemical and Alcohol Technology'
  },
  { value: 'Chemical Engineering (CHE)', label: 'Chemical Engineering (CHE)' },
  { value: 'Chemistry', label: 'Chemistry' },
  { value: 'Civil Engineering (CE)', label: 'Civil Engineering (CE)' },
  { value: 'Commerce', label: 'Commerce' },
  {
    value: 'Computer Science Engineering (CSE)',
    label: 'Computer Science Engineering (CSE)'
  },
  { value: 'Corrosion Engineering', label: 'Corrosion Engineering' },
  { value: 'Cryptographic Engineering', label: 'Cryptographic Engineering' },
  {
    value: 'Naval Architecture and Ocean Engineering',
    label: 'Naval Architecture and Ocean Engineering'
  },
  { value: 'Economics', label: 'Economics' },
  {
    value: 'Electrical & Electronics Engineering (EEE)',
    label: 'Electrical & Electronics Engineering (EEE)'
  },
  {
    value: 'Electrical Engineering (EE)',
    label: 'Electrical Engineering (EE)'
  },
  {
    value: 'Electrical Engineering-Power & Automation',
    label: 'Electrical Engineering-Power & Automation'
  },
  {
    value: 'Electronics & Communication Engineering (ECE)',
    label: 'Electronics & Communication Engineering (ECE)'
  },
  {
    value: 'Electronics & Instrumentation Engineering (EIE)',
    label: 'Electronics & Instrumentation Engineering (EIE)'
  },
  {
    value: 'Electronics & Telecommunication Engineering (ETE)',
    label: 'Electronics & Telecommunication Engineering (ETE)'
  },
  {
    value: 'Electronics & Electrical Communication Engineering',
    label: 'Electronics & Electrical Communication Engineering'
  },
  { value: 'Electronics Engineering', label: 'Electronics Engineering' },
  {
    value: 'Electronics Instrumentation & Control',
    label: 'Electronics Instrumentation & Control'
  },
  { value: 'Energy Engineering', label: 'Energy Engineering' },
  { value: 'Engineering Physics', label: 'Engineering Physics' },
  { value: 'Environmental Engineering', label: 'Environmental Engineering' },
  { value: 'Finance', label: 'Finance' },
  { value: 'Food Technology', label: 'Food Technology' },
  { value: 'Geotechnical Engineering', label: 'Geotechnical Engineering' },
  {
    value: 'Industrial and Systems Engineering',
    label: 'Industrial and Systems Engineering'
  },
  {
    value: 'Industrial Engineering (IE)',
    label: 'Industrial Engineering (IE)'
  },
  {
    value: 'Industrial and Production Engineering (IPE)',
    label: 'Industrial and Production Engineering (IPE)'
  },
  {
    value: 'Information Science and Engineering',
    label: 'Information Science and Engineering'
  },
  {
    value: 'Information Technology (IT)',
    label: 'Information Technology (IT)'
  },
  { value: 'Instrumentation & Control', label: 'Instrumentation & Control' },
  {
    value: 'Instrumentation Engineering',
    label: 'Instrumentation Engineering'
  },
  { value: 'Leather Technology', label: 'Leather Technology' },
  { value: 'Biological Sciences', label: 'Biological Sciences' },
  { value: 'Man Made Fibre Technology', label: 'Man Made Fibre Technology' },
  { value: 'Management Engineering', label: 'Management Engineering' },
  { value: 'Manufacturing Engineering', label: 'Manufacturing Engineering' },
  { value: 'Manufacturing Technology', label: 'Manufacturing Technology' },
  { value: 'Marine Engineering', label: 'Marine Engineering' },
  { value: 'Marketing', label: 'Marketing' },
  { value: 'Material Science', label: 'Material Science' },
  { value: 'Materials Engineering', label: 'Materials Engineering' },
  { value: 'Mathematics', label: 'Mathematics' },
  {
    value: 'Mechanical & Industrial Engineering',
    label: 'Mechanical & Industrial Engineering'
  },
  {
    value: 'Mechanical Engineering (ME)',
    label: 'Mechanical Engineering (ME)'
  },
  { value: 'Mechatronics Engineering', label: 'Mechatronics Engineering' },
  { value: 'Metallurgical Engineering', label: 'Metallurgical Engineering' },
  {
    value: 'Metallurgical and Materials Engineering (MME)',
    label: 'Metallurgical and Materials Engineering (MME)'
  },
  { value: 'Military Engineering', label: 'Military Engineering' },
  { value: 'Mining Engineering', label: 'Mining Engineering' },
  { value: 'Molecular Engineering', label: 'Molecular Engineering' },
  { value: 'Nano Engineering', label: 'Nano Engineering' },
  { value: 'Nuclear Engineering', label: 'Nuclear Engineering' },
  {
    value: 'Ocean Engineering and Naval Architecture',
    label: 'Ocean Engineering and Naval Architecture'
  },
  { value: 'Oil Technology', label: 'Oil Technology' },
  { value: 'Optical Engineering', label: 'Optical Engineering' },
  { value: 'Optomechanical Engineering', label: 'Optomechanical Engineering' },
  { value: 'Petrochemical engineering', label: 'Petrochemical engineering' },
  { value: 'Petroleum Engineering', label: 'Petroleum Engineering' },
  { value: 'Plastic Technology', label: 'Plastic Technology' },
  { value: 'Power Engineering', label: 'Power Engineering' },
  { value: 'Power Plant Engineering', label: 'Power Plant Engineering' },
  { value: 'Process Engineering', label: 'Process Engineering' },
  {
    value: 'Production & Industrial Engineering',
    label: 'Production & Industrial Engineering'
  },
  { value: 'Production Engineering', label: 'Production Engineering' },
  { value: 'Railway Engineering', label: 'Railway Engineering' },
  { value: 'Rural Management (RM)', label: 'Rural Management (RM)' },
  { value: 'Software Engineering', label: 'Software Engineering' },
  { value: 'Sports Engineering', label: 'Sports Engineering' },
  {
    value: 'Statistics for Business Management',
    label: 'Statistics for Business Management'
  },
  { value: 'Structural Engineering', label: 'Structural Engineering' },
  { value: 'Systems Engineering', label: 'Systems Engineering' },
  { value: 'Teletraffic Engineering', label: 'Teletraffic Engineering' },
  { value: 'Textile Engineering', label: 'Textile Engineering' },
  { value: 'Thermal Engineering', label: 'Thermal Engineering' },
  { value: 'Transport Engineering', label: 'Transport Engineering' },
  { value: 'Vehicle Engineering', label: 'Vehicle Engineering' },
  {
    value: 'Water Resources Engineering',
    label: 'Water Resources Engineering'
  },
  { value: 'Web Engineering', label: 'Web Engineering' },
  { value: 'Physics', label: 'Physics' },
  {
    value: 'Humanities and Social Sciences',
    label: 'Humanities and Social Sciences'
  },
  { value: 'Genetic Engineering', label: 'Genetic Engineering' },
  { value: 'Geophysics', label: 'Geophysics' },
  { value: 'Engineering Design', label: 'Engineering Design' },
  { value: 'Applied Geology', label: 'Applied Geology' },
  { value: 'Applied Mechanics', label: 'Applied Mechanics' },
  {
    value: 'Architecture and Regional Planning',
    label: 'Architecture and Regional Planning'
  },
  {
    value: 'Computational Engineering and Networking (CEN)',
    label: 'Computational Engineering and Networking (CEN)'
  },
  { value: 'Communication Systems', label: 'Communication Systems' },
  {
    value: 'Electronics and Computer Engineering',
    label: 'Electronics and Computer Engineering'
  },
  { value: 'Engineering Sciences', label: 'Engineering Sciences' },
  { value: 'Geology and Geophysics', label: 'Geology and Geophysics' },
  {
    value: 'Strength of Materials (SOM)',
    label: 'Strength of Materials (SOM)'
  },
  { value: 'Mathematics and Computing', label: 'Mathematics and Computing' },
  { value: 'Mining Safety Engineering', label: 'Mining Safety Engineering' },
  { value: 'Biology', label: 'Biology' },
  {
    value: 'Chemical & Polymer Engineering',
    label: 'Chemical & Polymer Engineering'
  },
  {
    value: 'Electrical and Information Engineering',
    label: 'Electrical and Information Engineering'
  },
  { value: 'Information Systems', label: 'Information Systems' },
  { value: 'Avionics', label: 'Avionics' },
  { value: 'Physical Science', label: 'Physical Science' },
  {
    value: 'Manufacturing Science and Engineering',
    label: 'Manufacturing Science and Engineering'
  },
  {
    value: 'Quality Engineering Design and Manufacturing',
    label: 'Quality Engineering Design and Manufacturing'
  },
  {
    value: 'Polymer Science and Technology',
    label: 'Polymer Science and Technology'
  },
  {
    value: 'Electrical and Communications Engineering',
    label: 'Electrical and Communications Engineering'
  },
  {
    value: 'Electronics and Telecommunication Engineering',
    label: 'Electronics and Telecommunication Engineering'
  },
  { value: 'Mechanical Design Engineer', label: 'Mechanical Design Engineer' },
  { value: 'Digital Marketing', label: 'Digital Marketing' },
  {
    value: 'Electronics Engineering - Design and Manufacturing',
    label: 'Electronics Engineering - Design and Manufacturing'
  },
  { value: 'Design', label: 'Design' },
  { value: 'Computer Management', label: 'Computer Management' },
  {
    value: 'Human Resources (HR) & Marketing',
    label: 'Human Resources (HR) & Marketing'
  },
  {
    value: 'Information and Communication Technology',
    label: 'Information and Communication Technology'
  },
  { value: 'Medical Nanotechnology', label: 'Medical Nanotechnology' },
  { value: 'Zoology', label: 'Zoology' },
  {
    value: 'Manufacturing Systems Engineering',
    label: 'Manufacturing Systems Engineering'
  },
  { value: 'Data Analytics', label: 'Data Analytics' },
  {
    value: 'Mass Communication and Journalism',
    label: 'Mass Communication and Journalism'
  },
  { value: 'Commerce and Management', label: 'Commerce and Management' },
  { value: 'Marketing and Operations', label: 'Marketing and Operations' },
  { value: 'Management', label: 'Management' },
  {
    value: 'Electronics & Computer Engineering',
    label: 'Electronics & Computer Engineering'
  },
  { value: 'Entrepreneurship', label: 'Entrepreneurship' },
  { value: 'Computer Applications', label: 'Computer Applications' },
  { value: 'Chemical', label: 'Chemical' },
  { value: 'Biochemistry', label: 'Biochemistry' },
  { value: 'Finance & Marketing', label: 'Finance & Marketing' },
  { value: 'Human Resources (HR)', label: 'Human Resources (HR)' },
  {
    value: 'Department of Management studies (DMS)',
    label: 'Department of Management studies (DMS)'
  },
  {
    value: 'Marketing & Human Resources (HR)',
    label: 'Marketing & Human Resources (HR)'
  },
  {
    value: 'Human Resources (HR) & Finance',
    label: 'Human Resources (HR) & Finance'
  },
  {
    value: 'Computing and Information Technology',
    label: 'Computing and Information Technology'
  },
  {
    value: 'Digital and Offline Marketing',
    label: 'Digital and Offline Marketing'
  },
  { value: 'Medical Electronics', label: 'Medical Electronics' },
  { value: 'Earth Sciences', label: 'Earth Sciences' },
  { value: 'Marketing Operations', label: 'Marketing Operations' },
  { value: 'Data Science', label: 'Data Science' },
  {
    value: 'Computer Science & Information Systems',
    label: 'Computer Science & Information Systems'
  },
  {
    value: 'Advanced Construction Management (ACM)',
    label: 'Advanced Construction Management (ACM)'
  },
  {
    value: 'Computer Integrated Design & Manufacturing',
    label: 'Computer Integrated Design & Manufacturing'
  },
  {
    value: 'Construction Management (CM)',
    label: 'Construction Management (CM)'
  },
  { value: 'Microelectronics', label: 'Microelectronics' },
  {
    value: 'Food Processing & Engineering',
    label: 'Food Processing & Engineering'
  },
  {
    value: 'Information Security & Digital Forensics',
    label: 'Information Security & Digital Forensics'
  },
  { value: 'Chartered Accountant (CA)', label: 'Chartered Accountant (CA)' },
  {
    value: 'Pharma Tech. & Healthcare Management',
    label: 'Pharma Tech. & Healthcare Management'
  },
  {
    value: 'Computer Science & Information Technology (CSIT)',
    label: 'Computer Science & Information Technology (CSIT)'
  },
  { value: 'Finance Management', label: 'Finance Management' },
  {
    value: 'Electronics Design & Manufacturing',
    label: 'Electronics Design & Manufacturing'
  },
  { value: 'Other', label: 'Other' }
];

export { departmentOptions };
